import { EstimatedTradeCostRequest } from 'widgets/estimatedTradeCost/store/data/EstimatedTradeCostRequest';
import { EstimatedTradeCostOptimization } from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostConfigState';
import {
    EstimatedTradeCostOrderDataState,
    extractMessages as extractRequestMessages,
} from 'widgets/estimatedTradeCost/store/data/EstimateTradeCostDataState';
import { StreamMessage } from 'utils/messages/StreamMessage';
import uniq from 'lodash/uniq';
import flatten from 'lodash/flatten';

export type EstimatedTradeCostComparisonData = {
    specifiedQty?: number;
    allCompleted: boolean;
    haveFailure: boolean;
    firstRequest?: EstimatedTradeCostRequest;
    requests: Array<{
        uid: string;
        config: EstimatedTradeCostOptimization;
        data: EstimatedTradeCostOrderDataState | undefined;
    }>;
};

export function extractMessages(
    data: EstimatedTradeCostComparisonData
): StreamMessage[] {
    return uniq(
        flatten(
            data.requests.map((r) =>
                extractRequestMessages(r.data).map((m) => m.message)
            )
        )
    ).map((message) => ({ message }));
}
